// /no-access — Figma frame 10 no-access (33:3013). Owner: screens-shell, US-103.
//
// The screen decides its own chrome. Frame 10 instances `Screen/Template`, so a
// signed-in caller gets the shell (and with it a sign-out) scoped to the org
// they DO belong to; a caller with no session has no org for a sidebar to point
// at and gets the panel alone.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { NoAccessScreen } from "../screens/overview";

export const noAccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/no-access",
  component: NoAccessScreen,
});
